import React from 'react';
import { FounderStory } from '../components/sections/FounderStory';
import { CoreBeliefs } from '../components/sections/CoreBeliefs';
import { OurMission } from '../components/sections/OurMission';
export function About() {
  return <div className="pt-20" data-id="element-1173">
      {/* Hero */}
      <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-br from-gray-50 to-white" data-id="element-1174">
        <div className="container-custom" data-id="element-1175">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1176">
            <div className="inline-block bg-amber-light text-amber-dark px-4 py-2 rounded text-sm font-semibold mb-6" data-id="element-1177">
              Our Story
            </div>
            <h1 className="mb-6" data-id="element-1178">Built by Operators. Designed for Growth.</h1>
            <p className="text-body-large leading-relaxed mb-8" data-id="element-1179">
              HIRE wasn't built by consultants. It was built by door-to-door
              guys. We understand the grind, the rejection, and the pressure to
              grow a team.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-1180">
              <div className="text-center" data-id="element-1181">
                <div className="text-3xl font-bold text-amber mb-1" data-id="element-1182">4,000+</div>
                <div className="text-sm" data-id="element-1183">Total Reps Recruited</div>
              </div>
              <div className="text-center" data-id="element-1184">
                <div className="text-3xl font-bold text-amber mb-1" data-id="element-1185">200K+</div>
                <div className="text-sm" data-id="element-1186">Doors Knocked</div>
              </div>
              <div className="text-center" data-id="element-1187">
                <div className="text-3xl font-bold text-amber mb-1" data-id="element-1188">$130M+</div>
                <div className="text-sm" data-id="element-1189">Sales Generated</div>
              </div>
              <div className="text-center" data-id="element-1190">
                <div className="text-3xl font-bold text-amber mb-1" data-id="element-1191">60+</div>
                <div className="text-sm" data-id="element-1192">Combined Team Experience</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Story */}
      <FounderStory data-id="element-1193" />

      {/* Core Beliefs */}
      <CoreBeliefs data-id="element-1194" />

      {/* Our Mission */}
      <OurMission data-id="element-1195" />

      {/* Final CTA */}
      <section className="section-padding bg-gray-50" data-id="element-1196">
        <div className="container-custom" data-id="element-1197">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1198">
            <h2 className="mb-6" data-id="element-1199">If This Resonates, Let's Talk</h2>
            <p className="text-body-large mb-8 leading-relaxed" data-id="element-1200">
              We work best with leaders who value systems over shortcuts.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1201">
              <a href="/book-call" className="inline-block bg-amber hover:bg-amber-dark text-navy font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1202">
                Schedule a Strategy Call →
              </a>
              <a href="/case-studies" className="inline-block border-2 border-navy text-navy hover:bg-navy hover:text-white font-bold px-8 py-4 rounded-lg transition-colors" data-id="element-1203">
                See Our Results
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}